var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.864,
    height: 37.474,
    viewBox: "0 0 37.864 37.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1208",
    "data-name": "Group 1208",
    transform: "translate(14547.148 -14682.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M-14525.844,14694.424a.6.6,0,0,1-.445-.2l-5.248-5.8a.6.6,0,0,1-.1-.646.6.6,0,0,1,.549-.356h2.024v-4.513a.6.6,0,0,1,.6-.6h5.331a.6.6,0,0,1,.6.6v4.513h1.889a.6.6,0,0,1,.548.354.6.6,0,0,1-.1.646l-5.2,5.8a.6.6,0,0,1-.445.2Zm-3.9-5.8,3.895,4.306,3.854-4.306h-1.146a.6.6,0,0,1-.6-.6v-4.513h-4.132v4.513a.6.6,0,0,1-.6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M21,29.934a.608.608,0,0,1-.263-.08L7.551,22.216a.6.6,0,0,1-.3-.519v-1.7H3.192a.6.6,0,0,1,0-1.2h6.826a.6.6,0,0,1,0,1.2H8.451v1.357l12.125,7.021V16.282L19.041,18.96a.6.6,0,0,1-.823.22L8.451,13.463v1.064a.6.6,0,1,1-1.2,0V12.812c0-.017,0-.034,0-.05L4.892,11.38a.6.6,0,0,1-.219-.815L7.193,6.153a.6.6,0,0,1,.094-.124.6.6,0,0,1,.266-.319L16.1.651a.6.6,0,0,1,.6,1.04L9.067,6.225l12.294,6.9,11.945-6.9L25.88,1.909A.6.6,0,0,1,26.485.872L34.8,5.713a.6.6,0,0,1,.205.2.6.6,0,0,1,.257.241l2.519,4.411a.6.6,0,0,1-.217.814l-2.361,1.393V21.4a.6.6,0,0,1-.294.517L21.481,29.876a.606.606,0,0,1-.48.057Zm.774-1.627,12.234-7.252V13.479l-9.659,5.7a.606.606,0,0,1-.3.083.6.6,0,0,1-.521-.3l-1.75-3.053ZM6.011,10.644,18.3,17.839l2.192-3.824L8.068,7.041Zm18.254,7.193,12.184-7.191L34.367,7,22.11,14.078ZM.6,17.174a.6.6,0,1,1,0-1.2H11.237a.6.6,0,0,1,0,1.2Z",
    transform: "translate(-14547.148 14689.825)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.d7b0d64a1d2a15597c13a35647e5b8f4.svg";
export { ForwardRef as ReactComponent };